export const PACKAGE_NAME = 'consultation';

export const CONSULTATION_ONBOARDING_MODAL_SHOWN_IN_LS = 'consultation-onboarding-modal';

export const ACTIVE_CONSULTATION_PACKAGE = 'ACTIVE';

export const QUERY_PARAMS = {
    AUTO_OPEN_CONSULTATION_MODAL: 'aoconsm',
    AUTO_OPEN_CONSULTATION_DRAWER: 'aoconsd',
} as const;

export const CONSULTATION_OVERLAY_COMPONENT = 'CONSULTATION_OVERLAY_COMPONENT';

export const OVERLAY_TYPES = {
    MODAL: 'modal',
    DRAWER: 'drawer',
} as const;

export const CONSULTATION_DEFAULT_RESPONSE = {};
